module.exports = __webpack_public_path__ + "static/media/Black_Small.0979c0f5.webp";